<template>
    <ul class="list-slice">
        <li v-for="(item, index) in slice.items" :key="index">
            <PrismicRichText :field="item.item" />
        </li>
    </ul>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {ListSlice} from '@prismicio-types';
    defineProps(getSliceComponentProps<ListSlice>());
</script>

<style lang="scss">
    @use '~/assets/styles/variables' as *;
    .list-slice {
        margin-bottom: var(--joy-core-spacing-7);
        list-style: none;
        padding-left: 30px;
        @include content-width($article-max-width);

        li {
            position: relative;
            margin-bottom: var(--joy-core-spacing-6);
            font-size: 18px;
        }
        li::before {
            content: url('~/assets/svg/checkCircle.svg');
            height: 22px;
            width: 22px;
            position: absolute;
            left: -30px;
            top: 1px;
        }
        .malt-strategy-theme & {
            li::before {
                content: url('~/assets/svg/checkCircleMs.svg');
            }
        }
    }
</style>
